"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
        },
        switch: {
            margin: 0,
        },
        title: {
            textTransform: 'capitalize',
        },
        switchBase: {
            color: "".concat(theme_1.default.colors.dark, " !important"),
            opacity: '1 !important',
            '&:hover': {
                background: 'transparent !important',
            },
            '&.Mui-checked': {
                color: "".concat(theme_1.default.colors.primary, " !important"),
            },
        },
        switchRoot: {
            marginLeft: 4,
        },
        disabled: {
            opacity: 0.5,
        },
        switchTrack: {
            backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.2), " !important"),
            height: 11,
            opacity: '1 !important',
        },
        switchTrackChecked: {
            backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primary, 0.2), " !important"),
        },
        label: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        },
        spacious: {
            marginLeft: 65,
        },
        fullWidth: {
            width: '100%',
        },
        icon: {
            marginRight: 4,
        },
    });
});
